<template>
    <div class="form-inline mb-2">
        <label class="mr-sm-2">Sort by</label>
        <b-form-select size="sm" v-model="selected" :options="options"/>
    </div>
</template>

<script>
    export default {
        name: 'SortFilter',
        data() {
            return {
                selected: 'recommended',
                options: [
                    { value: 'recommended', text: 'Recommended' },
                    { value: 'price', text: 'Price (lowest)' },
                    { value: 'distance', text: 'Distance (closest)' },
                ],
            }
        },
        props: {
            search: {
                type: Object,
                required: true
            },
        },
        methods: {
  
        },
        watch: {
            selected: function(value) {

                this.search.sort = value;

                this.$router.push({
                    path: `/${this.$route.params.locale}/hotels/`, query: {
                        search: this.search.place.name,
                        lat: this.search.place.lat,
                        lng: this.search.place.lng,
                        checkin: this.search.date.checkin,
                        checkout: this.search.date.checkout,
                        adults: this.search.occupation.adults,
                        children: this.search.occupation.children,
                        rooms: this.search.occupation.rooms,
                        ages: JSON.stringify(this.search.occupation.ages),
                        sort: this.search.sort,
                        page: this.search.page,
                    }
                });

                this.$emit("update-search", this.search);
            }
        },
    }
</script>

<style scoped>

</style>
